import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionFoodCostsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionFoodCosts.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionFoodCosts.button1'),
          value: 'very_concerned',
        },
        {
          text: t('pages.onboarding.questionFoodCosts.button2'),
          value: 'somewhat_concerned',
        },
        {
          text: t('pages.onboarding.questionFoodCosts.button3'),
          value: 'not_very_concerned',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
